<div class="rex-header">
    <div class="rex-brand">
        <img src="assets/img/rex.png" alt="Rex" class="rex-logo" />
        <div class="rex-title">
            <div class="name">{{ title }}</div>
            <div class="subtitle">
                {{ subtitle }}
            </div>
        </div>
    </div>
    <button type="button" class="btn-icon" (click)="cerrar()" aria-label="Cerrar">×</button>
</div>

<div class="rex-body">
    <div class="hint">
        <div class="assistant-bubble" *ngIf="!cargando; else rexLoading">
            Escribe un contexto sencillo para generar tu descripción: qué haces, para quién y qué quieres lograr.
        </div>
        <ng-template #rexLoading>
            <div class="assistant-bubble" style="display:flex;align-items:center;gap:8px;justify-content:center;">
                <span>Cargando, generando contenido…</span>
                <span class="rex-spinner" aria-label="Generando"></span>
            </div>
        </ng-template>
    </div>

    <div class="query-box" [class.focused]="inputFocused">
        <div class="qb-row">
            <input #rexInput class="qb-input" [(ngModel)]="context" (focus)="inputFocused=true" (blur)="inputFocused=false" placeholder="Escribe aquí…" />
            <button class="qb-send" [disabled]="cargando || !context || context.length < 20" (click)="generar()">{{ cargando ? '...' : '▶' }}</button>
        </div>
    </div>

    <div *ngIf="error" class="error">{{ error }}</div>
    <div *ngIf="!error && context && context.trim().length > 0 && context.trim().length < 20" class="error">Escribe un poco más de contexto (mínimo 20 caracteres).</div>
</div>